import { Physical } from './entities/Physical';
import { StatePropertyRef } from './ExtendableStore';

export const RootOverride = StatePropertyRef<Physical>('rootOverride');
